//@flow

import styled from "styled-components"
import * as BaseUI from "../UI"

export const TitleText = BaseUI.TitleText.extend`
  position: absolute;
  right: 0;
  min-width: 100%;
`

export const TitleDescription = BaseUI.TitleDescription.extend`
  text-shadow: 1px 1px 5px rgba(0,0,0,0.95);
  color: #fff;
  padding-top: 200px;
`

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background: #a5d9f2;
`

export const Titles = styled.div`
  position: absolute;
  top: 104px;
  right: 104px;
  width: 600px;
  z-index: 1;
`

export const Foreground = styled.div`
  position: absolute;
  top: 0px;
  left: -150px;
  height: 766px;
  width: 1260px;
  z-index: 2;
`

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: -100px;
  height: 780px;
  width: 2143px;
  z-index: 0;
`



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Fuel/UI.js